export const ALLOWED_MESSAGE_REACTIONS_LIST = [
  "👍", "👎", "❤️", "🔥", "😂", "😮", "😢", "👏", "🙏", "😎", "🏆", "😍", "🥳", "🎉", "✨", "🤩", "😁", "💪", "😡", "🫡", "😴", "🤯", "👀", "🤝", "👌", "✍️", "💯", "🕐", "⚡️", "🤬"
];

export const ALLOWED_MESSAGE_REACTIONS = new Set(ALLOWED_MESSAGE_REACTIONS_LIST);

export const REACTION_CUSTOM_IMAGE_URL_BY_EMOJI = {
  "👍": "/reactions/like.png",
  "👎": "/reactions/dislike.png",
  "❤️": "/reactions/heart.png",
  "🔥": "/reactions/fire.png",
  "😂": "/reactions/smile.png",
  "😮": "/reactions/surprised.png",
  "😢": "/reactions/sad.png",
  "👏": "/reactions/clap.png",
  "😎": "/reactions/sunglasses.png",
  "🙏": "/reactions/pray.png",
  "🏆": "/reactions/trophy.png",
  "😍": "/reactions/in-love.png",
  "🥳": "/reactions/party.png",
  "🎉": "/reactions/confetti.png",
  "✨": "/reactions/stars.png",
  "🤩": "/reactions/wow.png",
  "😁": "/reactions/smile2.png",
  "💪": "/reactions/strong.png",
  "😡": "/reactions/angry.png",
  "🫡": "/reactions/ok2.png",
  "😴": "/reactions/sleep.png",
  "🤯": "/reactions/mind-blown.gif",
  "👀": "/reactions/eyes.png",
  "🤝": "/reactions/handshake.png",
  "👌": "/reactions/ok.png",
  "✍️": "/reactions/write.png",
  "💯": "/reactions/perfect.png",
  "🕐": "/reactions/clock.png",
  "⚡️": "/reactions/ac.png",
  "🤬": "/reactions/headbang.gif",
};

function resolveReactionCustomImageUrl(emoji) {
  const e = (emoji || '').trim();
  if (!e) return null;
  const map = REACTION_CUSTOM_IMAGE_URL_BY_EMOJI;
  if (map[e]) return map[e];
  const noVs = e.replace(/\uFE0F/g, '');
  if (noVs !== e && map[noVs]) return map[noVs];
  if (!e.includes('\uFE0F') && map[`${e}\uFE0F`]) return map[`${e}\uFE0F`];
  return null;
}

export function isAllowedReaction(emoji) {
  const e = (emoji || '').trim();
  if (ALLOWED_MESSAGE_REACTIONS.has(e)) return true;
  return false;
}

let reactionImagesPreloadPromise = null;
const reactionBlobUrlByOriginalUrl = new Map();

function getCachedReactionUrl(url) {
  if (!url) return null;
  return reactionBlobUrlByOriginalUrl.get(url) || url;
}

export function preloadReactionImages() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (reactionImagesPreloadPromise) return reactionImagesPreloadPromise;

  const urls = Array.from(
    new Set(
      Object.values(REACTION_CUSTOM_IMAGE_URL_BY_EMOJI).filter(Boolean),
    ),
  );

  reactionImagesPreloadPromise = Promise.allSettled(
    urls.map(async (url) => {
      try {
        const res = await fetch(url, { cache: 'force-cache' });
        if (!res.ok) return;
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        reactionBlobUrlByOriginalUrl.set(url, blobUrl);
      } catch {
      }
    }),
  ).then(() => undefined);

  return reactionImagesPreloadPromise;
}

export function getReactionCustomImageUrl(emoji) {
  const resolved = resolveReactionCustomImageUrl(emoji);
  return getCachedReactionUrl(resolved);
}
